import { Button, Typography } from "@mui/material";
import React, { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import Layout from "../components/layouts/Layout";

const OrderPlaced = () => {
  return (
   <Fragment>
    <Layout title={""} logo={"/assets/images/logo.jpeg"}>
    <div className="confirmed-order">
      <div className="confirmed-img">
        <img
          src={process.env.PUBLIC_URL + "assets/images/confirmed.gif"}
          alt="confirmed"
        />
      </div>
      <Typography variant="h5" component="h5" sx={{ fontWeight: "bold" }}>
        <span className="highlight">Congratulations</span> Your order placed
        successfully!
      </Typography>
      <Link to="/account">
        <Button
          variant="outlined"
          color="error"
          sx={{ textAlign: "center" }}
          className="mt20"
        >
          View My Orders
        </Button>
      </Link>
    </div>
    </Layout>
   </Fragment>
  );
};

export default OrderPlaced;
